import {forwardRef, useMemo} from "react";
import {Quantity} from "@ots-frontend/ots-data";
import {DefaultText, DefaultTextProps} from "../DefaultText/DefaultText";
import {Text} from "@mantine/core";

export type FormattedQuantityProps = Omit<DefaultTextProps, 'value'> & {
  value: (number | undefined) | Partial<Quantity>
  options?: Intl.NumberFormatOptions
}

export const getFormattedQuantity = (value: number | undefined, units: string | undefined = undefined, options: Intl.NumberFormatOptions | undefined = undefined): string | undefined => {
  if (typeof value === 'undefined') {
    return undefined
  }

  let formattedValue = new Intl.NumberFormat(undefined, options ?? {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value)

  if (units) {
    formattedValue += " "
    formattedValue += units
  }

  return formattedValue
};

export const FormattedQuantity = forwardRef<HTMLDivElement, FormattedQuantityProps>((props, ref) => {
  const {value, options, defaultValue, ...rest} = props;

  const formattedValue = useMemo(() => {
    let numberValue: number | undefined = undefined
    let unitsValue: string | undefined = undefined

    if (typeof value === 'number') {
      numberValue = value
    } else if (value) {
      numberValue = value.number
      unitsValue = value.units
    }

    if (typeof numberValue === 'undefined') {
      return undefined
    }
    return getFormattedQuantity(numberValue, unitsValue, options)
  }, [value, options])

  if (!formattedValue) {
    return <DefaultText ref={ref} {...rest} defaultValue={defaultValue}/>
  }

  return (
    <Text ref={ref} {...rest}>
      {formattedValue}
    </Text>
  );
});
